import { apiClient } from "@/lib/api/api-client"
import { Building } from "../types/building"

export const buildingApi = {
  getBuildings: () => {
    return apiClient.get<Building[]>(`building`, {})
  },

  getBuilding: (id: string) => {
    return apiClient.get<Building>(`building/${id}`)
  },

  createBuilding: (payload: any) => {
    return apiClient.post<Building>(`building`, payload)
  },

  updateBuilding: (id: string, payload: any) => {
    return apiClient.put<Building>(`building/${id}`, payload)
  },

  deleteBuilding: (id: string) => {
    return apiClient.delete<void>(`building/${id}`)
  },
}